/**
 * PRNG seedé (mulberry32). RÈGLE : la simulation n'utilise JAMAIS Math.random —
 * toute aléa passe par un générateur seedé, sinon les scénarios ne sont plus
 * reproductibles et les screenshots déterministes (cf. PLAN.md §11) sautent.
 */
export type Prng = () => number;

export function mulberry32(seed: number): Prng {
  let s = seed >>> 0;
  return () => {
    s = (s + 0x6d2b79f5) | 0;
    let t = Math.imul(s ^ (s >>> 15), 1 | s);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Float dans [min, max). */
export function randRange(rng: Prng, min: number, max: number): number {
  return min + (max - min) * rng();
}
